import { ImagePreview } from '@components/common/ImagePreview';
import React from 'react';
import * as S from './styled';
export const VariantImageCell = ({ previewImage, showPreviewImage, imagesCount, isFirstOfGroup, isLastOfGroup, }) => (React.createElement(S.Container, null, showPreviewImage && (React.createElement(S.ImageContainer, { isLast: isLastOfGroup },
    isFirstOfGroup && (React.createElement(React.Fragment, null,
        !isLastOfGroup && React.createElement(S.FirstImageLine, null),
        React.createElement(ImagePreview, { image: previewImage, imagesCount: imagesCount }))),
    !isFirstOfGroup && !isLastOfGroup && React.createElement(S.ConsecutiveImageLine, null),
    !isFirstOfGroup && isLastOfGroup && React.createElement(S.LastImageLine, null)))));
